import React, { useState, useContext, useEffect } from "react";
import styles from "../Firing/Firing.module.css";
import { store } from "../../Components/HOC/State";
import UnitListItem from "../MilUnitList/UnitListItem";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faArrowLeft,
  } from "@fortawesome/free-solid-svg-icons";
import { axiosInstance } from "../../Helpers/axiosInstance";
import "react-datepicker/dist/react-datepicker.css";
import baseStyle from "../BaseList/BaseList.module.css";
import CheckModal from "../../Modals/Check/CheckModal";
import CheckInfo from "./CheckInfo";
import DatePicker from "react-datepicker";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BACKEND_URL } from "../../Helpers/constants";

const Check = () => {
    const [isBaseListShown, setIsBaseListShown] = useState(false);
    const [selectedName, setSelectedName] = useState("Զորամաս");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentBase, setCurrentBase] = useState();
    const [currentUnit, setCurrentUnit] = useState();
    const { fetchUnits, unitList, fetchBases, baseList } = useContext(store);
    const [corpuses, setCorpuses] = useState([]);
    const [search, setSearch] = useState("");
    const [isSelectedBase, setIsSelectedBase] = useState(null);
    const [selctedBase, setSelectedBase] = useState(null);
    const [added, setAdded] = useState(false);
    const [dateRange, setDateRange] = useState([null, null]);
    const [startDate, endDate] = dateRange

  useEffect(() => {
     fetchUnits();
   }, []);

    useEffect(() => {
       (async () => {
         const res = await axiosInstance.get("admin/corpuses");
         if (res.data.status) {
           setCorpuses(res.data.data);
         }
       })();
     }, []);

      useEffect(() => {
         if (added) {
           setTimeout(() => setAdded(false), 100);
         }
       }, [added]);

         const handleBackToUnits = () => {
    setIsBaseListShown(false);
    setSelectedName("Զորամաս");
    setCurrentUnit(null);
    setCurrentBase(null);
    setIsSelectedBase(false);
  };

  const changeSelectedBase = (base) => {
    setSelectedBase(base);
  };

  const getExcelByUnit = async (unit) => {
      const res = await axiosInstance.get(
        `/admin/check-excel/${unit}/${startDate.getTime()}-${endDate.getTime()}`,
      );
      if (!res.data.status) {
        toast.error("Ֆայլի գեներացման համար տվյալներ չեն հայտնաբերվել");
        return;
      }
      const { filePath } = res.data.data;
  
      const downloadLink = document.createElement("a");
      downloadLink.href = BACKEND_URL + filePath;
      downloadLink.download = "data.xlsx";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }


return (
    <div className={styles["main-div"]}>
      <div className={styles["body-div"]}>
        {!isBaseListShown && (
          <input
            type="text"
            placeholder="Որոնել"
            className={baseStyle["search-input"]}
            style={{ marginTop: "10px" }}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        )}

        <div className={styles["header-row"]}>
          {isBaseListShown && (
            <div className={styles["back-btn"]} onClick={handleBackToUnits}>
              <FontAwesomeIcon icon={faArrowLeft} />
            </div>
          )}
          <h2>{selectedName}</h2>
          {isBaseListShown && (
            <div>
              <FontAwesomeIcon
                icon={faPlus}
                className={styles["adding"]}
                title="Ավելացնել տվյալներ"
                 onClick={(e) => {
                  e.stopPropagation();
                  setSelectedBase(baseList.data[0]);
                  setCurrentBase(null)
                  setIsModalOpen(true);
                }}
              />
            </div>
          )}
        </div>

        <div className={styles["units-bases-div"]}>
          {!isBaseListShown ? (
            <div className={baseStyle["unit-list-container"]}>
              {!!unitList.filter(
                (el) =>
                  (el.unit_number.includes(search) ||
                    el.unit_close_number.includes(search)) &&
                  el.unit_corpus === "",
              ).length && (
                <div>
                  <h4 className={styles["corpus-header"]}>ՀԲԿ</h4>
                  {unitList
                    .filter(
                      (el) =>
                        (el.unit_number.includes(search) ||
                          el.unit_close_number.includes(search)) &&
                        el.unit_corpus === "",
                    )
                    .map((item, index) => (
                      <UnitListItem
                        key={index}
                        item={item}
                        index={index}
                        onClick={() => {
                          fetchBases(item.unit_number);
                          setIsBaseListShown(true);
                          setCurrentUnit(item);
                          setSelectedName("Հենակետեր");
                        }}
                      />
                    ))}
                </div>
              )}
              {corpuses.map((corpus, index) =>
                unitList.filter(
                  (el) =>
                    (el.unit_number.includes(search) ||
                      el.unit_close_number.includes(search)) &&
                    el.unit_corpus === corpus._id,
                ).length ? (
                  <div className={baseStyle["unit-list-container"]} key={index}>
                    <h4 className={styles["corpus-header"]}>
                      {corpus.corpus_number} {corpus.corpus_name}
                    </h4>
                    {unitList
                      .filter(
                        (el) =>
                          (el.unit_number.includes(search) ||
                            el.unit_close_number.includes(search)) &&
                          el.unit_corpus === corpus._id,
                      )
                      .map((item, index) => (
                        <UnitListItem
                          key={index}
                          item={item}
                          index={index}
                          onClick={() => {
                            fetchBases(item.unit_number);
                            setIsBaseListShown(true);
                            setCurrentUnit(item);
                            setSelectedName("Հենակետեր");
                          }}
                        />
                      ))}
                  </div>
                ) : (
                  ""
                ),
              )}
            </div>
          ) : baseList.data !== undefined && baseList.data.length > 0 ? (
            <>
            <div className="w-full flex justify-end">
                <div className="w-fit flex justify-end">
                  <DatePicker
                    selectsRange
                    startDate={startDate}
                    endDate={endDate}
                    onChange={(update) => {
                      setDateRange(update);
                    }}
                    placeholderText="Ժամանակահատված"
                    className="border-b border-b-gray-400 rounded-lg outline-none mr-4 text-center"
                    dateFormat="dd.MM.yyyy"
                  />
                  <img
                    src="/excel.png"
                    alt="Excel"
                    className={`${styles["excel-icon"]}`}
                    onClick={() => {
                      if(!startDate || !endDate){
                        toast.error("Խնդրում ենք ընտրել ժամանակահատված");
                        return;
                      }
                      getExcelByUnit(currentUnit._id);
                    }}
                  />
                </div>
            </div>
              {baseList.data.map((item, index) => (
                <div
                  key={index}
                  className={styles["editing-items"]}
                  onClick={() => {
                    currentBase && currentBase._id === item._id
                      ? setCurrentBase(null)
                      : setCurrentBase(baseList.data[index]);
                    if (!currentBase) {
                      setIsSelectedBase(!isSelectedBase);
                    } else {
                      if (currentBase._id === item._id) {
                        setIsSelectedBase(!isSelectedBase);
                      }
                    }
                  }}
                >
                  <div className={styles["base-left-side"]}>
                    <p>
                      {index + 1}. {item.base_number}
                    </p>
                  </div>
                  {isSelectedBase && currentBase?._id === item._id && (
                    <CheckInfo
                      baseList={baseList.data}
                      added={added}
                      base={currentBase}
                      item={item}
                      setIsSelectedBase={setIsSelectedBase}
                      changeSelectedBase={changeSelectedBase}
                      closeModal={() => {
                        setIsModalOpen(false);
                        setSelectedBase(null);
                      }}
                      unit={currentUnit}
                      setAdded={setAdded}
                    />
                  )}
                </div>
              ))}
            </>
          ) : (
            <div className={styles["empty"]}>Մուտքագրված հենակետեր չկան</div>
          )}
          {isModalOpen ? (
            <CheckModal
              base={selctedBase}
              baseList={baseList.data}
              changeSelectedBase={changeSelectedBase}
              closeModal={() => {
                setIsModalOpen(false);
                setSelectedBase(null);
              }}
              currentUnit={currentUnit}
              setAdded={setAdded}
            />
          ) : (
            ""
          )}
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default Check;
